import { create } from 'zustand';

export type AssistantPageContext = {
  route?: string;
  moduleId?: string;
  moduleTitle?: string;
  version?: string;
  workflowState?: string;
  taskId?: string;
};

type AssistantPageContextState = {
  pageContext: AssistantPageContext | null;
  setPageContext: (pageContext: AssistantPageContext | null) => void;
};

/**
 * assistantPageContextStore
 * ----
 * Holds the current screen context published by active pages for assistant turns.
 */
export const useAssistantPageContextStore = create<AssistantPageContextState>((set) => ({
  pageContext: null,
  setPageContext: (pageContext) => set({ pageContext }),
}));
